<div class="modal-header">
  <h5 class="modal-title">Delete</h5>
  <button type="button" class="close" aria-label="Close" (click)="onCancel()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <p>Are you sure you want to delete this record?</p>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary me-2" (click)="onCancel()">Cancel</button>
  <button type="button" class="btn btn-primary" (click)="onConfirm()">Confirm</button>
</div>
